export class OutOfStockSynchronizationResponseDto {
  syncResult?: any;
}
